import { AppLanguage } from '~/types/locale'

export function extractLocaleAndHref(url: string): { locale: AppLanguage | undefined; href: string } {
  const regex = /^(?:\/(no|en|uk))?(\b.*)/
  const match = url.match(regex)
  if (match) {
    const locale = match[1] ? (match[1] as AppLanguage) : undefined
    return {
      locale,
      href: match[2] || '',
    }
  }
  return {
    locale: undefined,
    href: url,
  }
}

export type OracleLinkType = 'bootcamp' | 'encyclopedia' | 'curriculum' | 'standalone' | null

// Anchored to the start of the path (after stripping any locale prefix), not a substring match —
// a v1-migrated in-curriculum slug can legitimately contain "bootcamp" (e.g. bootcamp_algebra_...),
// which a `.includes('/bootcamp')` check would misclassify as an actual bootcamp link.
export function getOracleLinkType(rawHref: string): OracleLinkType {
  const { href } = extractLocaleAndHref(rawHref)
  if (href.startsWith('/curriculum/v2/grade-')) return 'curriculum'
  if (href.startsWith('/content/')) return 'standalone'
  if (href.startsWith('/bootcamp/')) return 'bootcamp'
  if (href.startsWith('/encyclopedia/')) return 'encyclopedia'
  return null
}
